import { css } from "@emotion/react";

import Image from "core/Components/Image";
import theme from "theme/index";
import ContentCombine from "core/Components/ContentCombine";
import ItemDescription from "pages/Components/CartAndCheckout/components/Item/ItemDescription";

type Props = {
    event: EventPage,
    className?: string,
    imagePercent?: number,
}

const RelatedEventPage = ({ event, className = "", imagePercent = 70 }: Props) => {
    const containerStyle = css`
        width: 400px;
        height: 400px;
        box-shadow: ${theme.borderAndShadow.boxShadow6};
        display: flex;
        flex-direction: column;
        border-radius: ${theme.borderAndShadow.largerRadius};
        overflow: hidden;

        ${theme.breakpoints.up('5xl')} {
            width: 500px;
            height: 520px;
        }

        ${theme.breakpoints.only('xl')} {
            width: 350px;
            height: 370px;
        }

        ${theme.breakpoints.down('lg')} {
            width: 290px;
            height: 345px;
        }

        ${theme.breakpoints.down('sm')} {
            width: 100%;
        }
    `;

    const bannerImageStyle = css`
        width: 100% !important;
        min-height: ${imagePercent}% !important;
        max-height: ${imagePercent}% !important;
        height: ${imagePercent}% !important;
        object-fit: cover;
    `;

    const textContainerStyle = css`
        min-height: ${100 - imagePercent}%;
        max-height: ${100 - imagePercent}%;
        height: ${100 - imagePercent}%;
        display: flex;
        flex-grow: 1;
        padding: 13px 14px 8px 11px;
        background-color: white;
    `;

    const titleStyle = css`
        color: ${theme.colours.curiousBlue2};
        justify-content: left;
        margin-bottom: 10px;
    `;

    const descriptionContainerStyle = css`
        display: flex;
        flex-direction: column;
        margin-top: 10px;
        padding-left: 5px;
        overflow: hidden;
        flex: 1;
    `;

    const titleAndDescStyle = css`
        display: flex;
        flex-direction: column;
        overflow: hidden;
        flex: 1;
    `;

    return (
        <div key={`related-event-${event.id}`} className={className}>
            <div css={containerStyle} className={className}>
                <Image
                    image={event.imagesAndVideos?.[0]?.image}
                    css={bannerImageStyle}
                />
                <div css={textContainerStyle} className={"text-container"}>
                    <div css={titleAndDescStyle}>
                        <div css={descriptionContainerStyle}>
                            <ContentCombine
                                Tag={'h6'}
                                css={titleStyle}
                                className={"header"}
                            >
                                {event.title}
                            </ContentCombine>
                            <ItemDescription
                                description={event.description}
                                truncateLineLimit={2}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RelatedEventPage;